<div class="reward-token-eligible-tag" *ngIf="tokenModel$ | async as tokenModel" [ngClass]="tokenModel.cssClass">
    {{ tokenModel.badgeText }}
</div>
